import styled from 'styled-components';

export const StdButton = styled.div`
  width: 100%;
  float: left;
  text-align: center;
`;
export const ArrowBT = styled.div`
  align-items: center;
  display: inline-grid;
  grid-template-columns: max-content repeat(1, auto);
  column-gap: 8px;
  span {
    line-height: initial;
    order: initial;
  }
`;
export const TextBT = styled.div`
  color: inherit;
  //margin: -2px 0px 2px;
  font-family: var(--font-family-text, vw-text, Helvetica, Arial, sans-serif);
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
`;

export const StdBox = styled.button`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  text-align: center;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  min-height: 44px;
  min-width: 44px;
  padding: 0px 32px;
  border: 2px solid rgb(0, 30, 80);
  margin: 0px;
  border-radius: 500px;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  color: rgb(0, 30, 80);
  background: rgb(255, 255, 255);

  &:hover::before {
    content: '';
    background-color: rgba(194, 202, 207, 0.2);

    border-radius: 500px;
    position: absolute;
    inset: 0px;
    margin: -2px;
  }
`;
